/* src/components/Episode.svelte generated by Svelte v3.32.3 */
import {
	SvelteComponent,
	append,
	attr,
	check_outros,
	children,
	claim_component,
	claim_element,
	claim_space,
	claim_text,
	component_subscribe,
	create_component,
	destroy_component,
	detach,
	element,
	empty,
	group_outros,
	init,
	insert,
	mount_component,
	noop,
	outro_and_destroy_block,
	safe_not_equal,
	set_data,
	space,
	text,
	toggle_class,
	transition_in,
	transition_out,
	update_keyed_each
} from "../_snowpack/pkg/svelte/internal.js";

import InformationCircleSmall from "./Icon/InformationCircleSmall.svelte.js";
import Position from "./Position.svelte.js";

import {
	allMarked,
	deduplicateStaff,
	hasAired,
	someMarked
} from "./utils.js";

import { createLocalization } from "./Lang/index.js";
import Localized from "./Lang/Localized.svelte.js";
import { getContext } from "../_snowpack/pkg/svelte.js";

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[14] = list[i];
	return child_ctx;
}

// (35:4) {#if episode}
function create_if_block(ctx) {
	let div;
	let current_block_type_index;
	let if_block0;
	let div_class_value;
	let t;
	let if_block1_anchor;
	let current;
	const if_block_creators = [create_if_block_3, create_if_block_4, create_if_block_5, create_if_block_6];
	const if_blocks = [];

	function select_block_type(ctx, dirty) {
		if (!/*aired*/ ctx[3]) return 0;
		if (/*waitingOnRelease*/ ctx[6]) return 1;
		if (/*noProgress*/ ctx[8]) return 2;
		if (/*inProgress*/ ctx[7]) return 3;
		return -1;
	}

	if (~(current_block_type_index = select_block_type(ctx, -1))) {
		if_block0 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
	}

	let if_block1 = /*latest*/ ctx[2] && create_if_block_1(ctx);

	return {
		c() {
			div = element("div");
			if (if_block0) if_block0.c();
			t = space();
			if (if_block1) if_block1.c();
			if_block1_anchor = empty();
			this.h();
		},
		l(nodes) {
			div = claim_element(nodes, "DIV", { class: true });
			var div_nodes = children(div);
			if (if_block0) if_block0.l(div_nodes);
			div_nodes.forEach(detach);
			t = claim_space(nodes);
			if (if_block1) if_block1.l(nodes);
			if_block1_anchor = empty();
			this.h();
		},
		h() {
			attr(div, "class", div_class_value = "text-gray-800 dark:text-gray-200 flex text-sm  mt-2 " + (/*shouldWrap*/ ctx[9] ? "flex-col" : "flex-row"));
			toggle_class(div, "col-start-1", /*uniqueStaff*/ ctx[4].length > 4);
			toggle_class(div, "col-end-3", /*uniqueStaff*/ ctx[4].length > 4);
		},
		m(target, anchor) {
			insert(target, div, anchor);

			if (~current_block_type_index) {
				if_blocks[current_block_type_index].m(div, null);
			}

			insert(target, t, anchor);
			if (if_block1) if_block1.m(target, anchor);
			insert(target, if_block1_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			let previous_block_index = current_block_type_index;
			current_block_type_index = select_block_type(ctx, dirty);

			if (current_block_type_index === previous_block_index) {
				if (~current_block_type_index) {
					if_blocks[current_block_type_index].p(ctx, dirty);
				}
			} else {
				if (if_block0) {
					group_outros();

					transition_out(if_blocks[previous_block_index], 1, 1, () => {
						if_blocks[previous_block_index] = null;
					});

					check_outros();
				}

				if (~current_block_type_index) {
					if_block0 = if_blocks[current_block_type_index];

					if (!if_block0) {
						if_block0 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
						if_block0.c();
					} else {
						if_block0.p(ctx, dirty);
					}

					transition_in(if_block0, 1);
					if_block0.m(div, null);
				} else {
					if_block0 = null;
				}
			}

			if (!current || dirty & /*shouldWrap*/ 512 && div_class_value !== (div_class_value = "text-gray-800 dark:text-gray-200 flex text-sm  mt-2 " + (/*shouldWrap*/ ctx[9] ? "flex-col" : "flex-row"))) {
				attr(div, "class", div_class_value);
			}

			if (dirty & /*shouldWrap, uniqueStaff*/ 528) {
				toggle_class(div, "col-start-1", /*uniqueStaff*/ ctx[4].length > 4);
			}

			if (dirty & /*shouldWrap, uniqueStaff*/ 528) {
				toggle_class(div, "col-end-3", /*uniqueStaff*/ ctx[4].length > 4);
			}

			if (/*latest*/ ctx[2]) {
				if (if_block1) {
					if_block1.p(ctx, dirty);

					if (dirty & /*latest*/ 4) {
						transition_in(if_block1, 1);
					}
				} else {
					if_block1 = create_if_block_1(ctx);
					if_block1.c();
					transition_in(if_block1, 1);
					if_block1.m(if_block1_anchor.parentNode, if_block1_anchor);
				}
			} else if (if_block1) {
				group_outros();

				transition_out(if_block1, 1, 1, () => {
					if_block1 = null;
				});

				check_outros();
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block0);
			transition_in(if_block1);
			current = true;
		},
		o(local) {
			transition_out(if_block0);
			transition_out(if_block1);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);

			if (~current_block_type_index) {
				if_blocks[current_block_type_index].d();
			}

			if (detaching) detach(t);
			if (if_block1) if_block1.d(detaching);
			if (detaching) detach(if_block1_anchor);
		}
	};
}

// (62:33) 
function create_if_block_6(ctx) {
	let localized;
	let current;

	localized = new Localized({
			props: {
				key: "SUBUNIT_IN_PROGRESS",
				$$slots: {
					default: [create_default_slot_4],
					"2": [create__2_slot_1],
					"0": [create__0_slot_3]
				},
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(localized.$$.fragment);
		},
		l(nodes) {
			claim_component(localized.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(localized, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const localized_changes = {};

			if (dirty & /*$$scope, uniqueStaff, episode*/ 131089) {
				localized_changes.$$scope = { dirty, ctx };
			}

			localized.$set(localized_changes);
		},
		i(local) {
			if (current) return;
			transition_in(localized.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(localized.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(localized, detaching);
		}
	};
}

// (54:33) 
function create_if_block_5(ctx) {
	let localized0;
	let t;
	let localized1;
	let current;

	localized0 = new Localized({
			props: {
				key: "SUBUNIT_WAS_PUBLISHED",
				$$slots: {
					default: [create_default_slot_3],
					"1": [create__1_slot_1],
					"0": [create__0_slot_2]
				},
				$$scope: { ctx }
			}
		});

	localized1 = new Localized({ props: { key: "SUBUNIT_NO_PROGRESS" } });

	return {
		c() {
			create_component(localized0.$$.fragment);
			t = space();
			create_component(localized1.$$.fragment);
		},
		l(nodes) {
			claim_component(localized0.$$.fragment, nodes);
			t = claim_space(nodes);
			claim_component(localized1.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(localized0, target, anchor);
			insert(target, t, anchor);
			mount_component(localized1, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const localized0_changes = {};

			if (dirty & /*$$scope, episode, timeAgo*/ 132097) {
				localized0_changes.$$scope = { dirty, ctx };
			}

			localized0.$set(localized0_changes);
		},
		i(local) {
			if (current) return;
			transition_in(localized0.$$.fragment, local);
			transition_in(localized1.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(localized0.$$.fragment, local);
			transition_out(localized1.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(localized0, detaching);
			if (detaching) detach(t);
			destroy_component(localized1, detaching);
		}
	};
}

// (50:39) 
function create_if_block_4(ctx) {
	let localized;
	let current;

	localized = new Localized({
			props: {
				key: "SUBUNIT_TO_RELEASE",
				$$slots: { "0": [create__0_slot_1] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(localized.$$.fragment);
		},
		l(nodes) {
			claim_component(localized.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(localized, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const localized_changes = {};

			if (dirty & /*$$scope, episode*/ 131073) {
				localized_changes.$$scope = { dirty, ctx };
			}

			localized.$set(localized_changes);
		},
		i(local) {
			if (current) return;
			transition_in(localized.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(localized.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(localized, detaching);
		}
	};
}

// (43:12) {#if !aired}
function create_if_block_3(ctx) {
	let localized;
	let current;

	localized = new Localized({
			props: {
				key: "SUBUNIT_NOT_PUBLISHED",
				$$slots: {
					default: [create_default_slot_1],
					"1": [create__1_slot],
					"0": [create__0_slot]
				},
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(localized.$$.fragment);
		},
		l(nodes) {
			claim_component(localized.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(localized, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const localized_changes = {};

			if (dirty & /*$$scope, episode, timeAgo*/ 132097) {
				localized_changes.$$scope = { dirty, ctx };
			}

			localized.$set(localized_changes);
		},
		i(local) {
			if (current) return;
			transition_in(localized.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(localized.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(localized, detaching);
		}
	};
}

// (64:20) <span slot="0">
function create__0_slot_3(ctx) {
	let span;
	let t_value = /*episode*/ ctx[0].number + "";
	let t;

	return {
		c() {
			span = element("span");
			t = text(t_value);
			this.h();
		},
		l(nodes) {
			span = claim_element(nodes, "SPAN", { slot: true });
			var span_nodes = children(span);
			t = claim_text(span_nodes, t_value);
			span_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(span, "slot", "0");
		},
		m(target, anchor) {
			insert(target, span, anchor);
			append(span, t);
		},
		p(ctx, dirty) {
			if (dirty & /*episode*/ 1 && t_value !== (t_value = /*episode*/ ctx[0].number + "")) set_data(t, t_value);
		},
		d(detaching) {
			if (detaching) detach(span);
		}
	};
}

// (66:24) {#each uniqueStaff as staff (staff.id)}
function create_each_block(key_1, ctx) {
	let first;
	let position;
	let current;

	position = new Position({
			props: { position: /*staff*/ ctx[14].position }
		});

	return {
		key: key_1,
		first: null,
		c() {
			first = empty();
			create_component(position.$$.fragment);
			this.h();
		},
		l(nodes) {
			first = empty();
			claim_component(position.$$.fragment, nodes);
			this.h();
		},
		h() {
			this.first = first;
		},
		m(target, anchor) {
			insert(target, first, anchor);
			mount_component(position, target, anchor);
			current = true;
		},
		p(new_ctx, dirty) {
			ctx = new_ctx;
			const position_changes = {};
			if (dirty & /*uniqueStaff*/ 16) position_changes.position = /*staff*/ ctx[14].position;
			position.$set(position_changes);
		},
		i(local) {
			if (current) return;
			transition_in(position.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(position.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(first);
			destroy_component(position, detaching);
		}
	};
}

// (65:20) <div slot="2" class="flex gap-1 mt-1">
function create__2_slot_1(ctx) {
	let div;
	let each_blocks = [];
	let each_1_lookup = new Map();
	let current;
	let each_value = /*uniqueStaff*/ ctx[4];
	const get_key = ctx => /*staff*/ ctx[14].id;

	for (let i = 0; i < each_value.length; i += 1) {
		let child_ctx = get_each_context(ctx, each_value, i);
		let key = get_key(child_ctx);
		each_1_lookup.set(key, each_blocks[i] = create_each_block(key, child_ctx));
	}

	return {
		c() {
			div = element("div");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			this.h();
		},
		l(nodes) {
			div = claim_element(nodes, "DIV", { slot: true, class: true });
			var div_nodes = children(div);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].l(div_nodes);
			}

			div_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(div, "slot", "2");
			attr(div, "class", "flex gap-1 mt-1");
		},
		m(target, anchor) {
			insert(target, div, anchor);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(div, null);
			}

			current = true;
		},
		p(ctx, dirty) {
			if (dirty & /*uniqueStaff*/ 16) {
				each_value = /*uniqueStaff*/ ctx[4];
				group_outros();
				each_blocks = update_keyed_each(each_blocks, dirty, get_key, 1, ctx, each_value, each_1_lookup, div, outro_and_destroy_block, create_each_block, null, get_each_context);
				check_outros();
			}
		},
		i(local) {
			if (current) return;

			for (let i = 0; i < each_value.length; i += 1) {
				transition_in(each_blocks[i]);
			}

			current = true;
		},
		o(local) {
			for (let i = 0; i < each_blocks.length; i += 1) {
				transition_out(each_blocks[i]);
			}

			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].d();
			}
		}
	};
}

// (63:16) <Localized key="SUBUNIT_IN_PROGRESS">
function create_default_slot_4(ctx) {
	let t;
	let current;

	return {
		c() {
			t = space();
		},
		l(nodes) {
			t = claim_space(nodes);
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		p: noop,
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (56:20) <span slot="0">
function create__0_slot_2(ctx) {
	let span;
	let t_value = /*episode*/ ctx[0].number + "";
	let t;

	return {
		c() {
			span = element("span");
			t = text(t_value);
			this.h();
		},
		l(nodes) {
			span = claim_element(nodes, "SPAN", { slot: true });
			var span_nodes = children(span);
			t = claim_text(span_nodes, t_value);
			span_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(span, "slot", "0");
		},
		m(target, anchor) {
			insert(target, span, anchor);
			append(span, t);
		},
		p(ctx, dirty) {
			if (dirty & /*episode*/ 1 && t_value !== (t_value = /*episode*/ ctx[0].number + "")) set_data(t, t_value);
		},
		d(detaching) {
			if (detaching) detach(span);
		}
	};
}

// (57:20) <time slot="1" datetime={episode.air_date}>
function create__1_slot_1(ctx) {
	let time;
	let t_value = /*timeAgo*/ ctx[10].format(new Date(/*episode*/ ctx[0].air_date)) + "";
	let t;
	let time_datetime_value;

	return {
		c() {
			time = element("time");
			t = text(t_value);
			this.h();
		},
		l(nodes) {
			time = claim_element(nodes, "TIME", { slot: true, datetime: true });
			var time_nodes = children(time);
			t = claim_text(time_nodes, t_value);
			time_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(time, "slot", "1");
			attr(time, "datetime", time_datetime_value = /*episode*/ ctx[0].air_date);
		},
		m(target, anchor) {
			insert(target, time, anchor);
			append(time, t);
		},
		p(ctx, dirty) {
			if (dirty & /*timeAgo, episode*/ 1025 && t_value !== (t_value = /*timeAgo*/ ctx[10].format(new Date(/*episode*/ ctx[0].air_date)) + "")) set_data(t, t_value);

			if (dirty & /*episode*/ 1 && time_datetime_value !== (time_datetime_value = /*episode*/ ctx[0].air_date)) {
				attr(time, "datetime", time_datetime_value);
			}
		},
		d(detaching) {
			if (detaching) detach(time);
		}
	};
}

// (55:16) <Localized key="SUBUNIT_WAS_PUBLISHED">
function create_default_slot_3(ctx) {
	let t;

	return {
		c() {
			t = space();
		},
		l(nodes) {
			t = claim_space(nodes);
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (52:20) <span slot="0">
function create__0_slot_1(ctx) {
	let span;
	let t_value = /*episode*/ ctx[0].number + "";
	let t;

	return {
		c() {
			span = element("span");
			t = text(t_value);
			this.h();
		},
		l(nodes) {
			span = claim_element(nodes, "SPAN", { slot: true });
			var span_nodes = children(span);
			t = claim_text(span_nodes, t_value);
			span_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(span, "slot", "0");
		},
		m(target, anchor) {
			insert(target, span, anchor);
			append(span, t);
		},
		p(ctx, dirty) {
			if (dirty & /*episode*/ 1 && t_value !== (t_value = /*episode*/ ctx[0].number + "")) set_data(t, t_value);
		},
		d(detaching) {
			if (detaching) detach(span);
		}
	};
}

// (45:20) <span slot="0">
function create__0_slot(ctx) {
	let span;
	let t_value = /*episode*/ ctx[0].number + "";
	let t;

	return {
		c() {
			span = element("span");
			t = text(t_value);
			this.h();
		},
		l(nodes) {
			span = claim_element(nodes, "SPAN", { slot: true });
			var span_nodes = children(span);
			t = claim_text(span_nodes, t_value);
			span_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(span, "slot", "0");
		},
		m(target, anchor) {
			insert(target, span, anchor);
			append(span, t);
		},
		p(ctx, dirty) {
			if (dirty & /*episode*/ 1 && t_value !== (t_value = /*episode*/ ctx[0].number + "")) set_data(t, t_value);
		},
		d(detaching) {
			if (detaching) detach(span);
		}
	};
}

// (46:20) <time slot="1" datetime={episode.air_date}>
function create__1_slot(ctx) {
	let time;
	let t_value = /*timeAgo*/ ctx[10].format(new Date(/*episode*/ ctx[0].air_date)) + "";
	let t;
	let time_datetime_value;

	return {
		c() {
			time = element("time");
			t = text(t_value);
			this.h();
		},
		l(nodes) {
			time = claim_element(nodes, "TIME", { slot: true, datetime: true });
			var time_nodes = children(time);
			t = claim_text(time_nodes, t_value);
			time_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(time, "slot", "1");
			attr(time, "datetime", time_datetime_value = /*episode*/ ctx[0].air_date);
		},
		m(target, anchor) {
			insert(target, time, anchor);
			append(time, t);
		},
		p(ctx, dirty) {
			if (dirty & /*timeAgo, episode*/ 1025 && t_value !== (t_value = /*timeAgo*/ ctx[10].format(new Date(/*episode*/ ctx[0].air_date)) + "")) set_data(t, t_value);

			if (dirty & /*episode*/ 1 && time_datetime_value !== (time_datetime_value = /*episode*/ ctx[0].air_date)) {
				attr(time, "datetime", time_datetime_value);
			}
		},
		d(detaching) {
			if (detaching) detach(time);
		}
	};
}

// (44:16) <Localized key="SUBUNIT_NOT_PUBLISHED">
function create_default_slot_1(ctx) {
	let t;

	return {
		c() {
			t = space();
		},
		l(nodes) {
			t = claim_space(nodes);
		},
		m(target, anchor) {
			insert(target, t, anchor);
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (73:8) {#if latest}
function create_if_block_1(ctx) {
	let div1;
	let div0;
	let t0;
	let span0;
	let localized;
	let t1;
	let div3;
	let div2;
	let span1;
	let t2_value = /*episode*/ ctx[0].season + "";
	let t2;
	let current;
	let if_block = /*status*/ ctx[1] && create_if_block_2(ctx);

	localized = new Localized({
			props: {
				key: "UNIT_UPDATED",
				$$slots: { "2": [create__2_slot] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			div1 = element("div");
			div0 = element("div");
			if (if_block) if_block.c();
			t0 = space();
			span0 = element("span");
			create_component(localized.$$.fragment);
			t1 = space();
			div3 = element("div");
			div2 = element("div");
			span1 = element("span");
			t2 = text(t2_value);
			this.h();
		},
		l(nodes) {
			div1 = claim_element(nodes, "DIV", { class: true });
			var div1_nodes = children(div1);
			div0 = claim_element(div1_nodes, "DIV", { class: true });
			var div0_nodes = children(div0);
			if (if_block) if_block.l(div0_nodes);
			t0 = claim_space(div0_nodes);
			span0 = claim_element(div0_nodes, "SPAN", {});
			var span0_nodes = children(span0);
			claim_component(localized.$$.fragment, span0_nodes);
			span0_nodes.forEach(detach);
			div0_nodes.forEach(detach);
			div1_nodes.forEach(detach);
			t1 = claim_space(nodes);
			div3 = claim_element(nodes, "DIV", { class: true });
			var div3_nodes = children(div3);
			div2 = claim_element(div3_nodes, "DIV", { class: true });
			var div2_nodes = children(div2);
			span1 = claim_element(div2_nodes, "SPAN", {});
			var span1_nodes = children(span1);
			t2 = claim_text(span1_nodes, t2_value);
			span1_nodes.forEach(detach);
			div2_nodes.forEach(detach);
			div3_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(div0, "class", "flex flex-row gap-1 text-left");
			attr(div1, "class", "absolute bottom-2 left-3 text-xs text-gray-400 dark:text-gray-300");
			attr(div2, "class", "flex flex-row text-right");
			attr(div3, "class", "absolute bottom-2 right-3 text-xs text-gray-400 dark:text-gray-300");
		},
		m(target, anchor) {
			insert(target, div1, anchor);
			append(div1, div0);
			if (if_block) if_block.m(div0, null);
			append(div0, t0);
			append(div0, span0);
			mount_component(localized, span0, null);
			insert(target, t1, anchor);
			insert(target, div3, anchor);
			append(div3, div2);
			append(div2, span1);
			append(span1, t2);
			current = true;
		},
		p(ctx, dirty) {
			if (/*status*/ ctx[1]) {
				if (if_block) {
					if_block.p(ctx, dirty);

					if (dirty & /*status*/ 2) {
						transition_in(if_block, 1);
					}
				} else {
					if_block = create_if_block_2(ctx);
					if_block.c();
					transition_in(if_block, 1);
					if_block.m(div0, t0);
				}
			} else if (if_block) {
				group_outros();

				transition_out(if_block, 1, 1, () => {
					if_block = null;
				});

				check_outros();
			}

			const localized_changes = {};

			if (dirty & /*$$scope, episode, timeAgo*/ 132097) {
				localized_changes.$$scope = { dirty, ctx };
			}

			localized.$set(localized_changes);
			if ((!current || dirty & /*episode*/ 1) && t2_value !== (t2_value = /*episode*/ ctx[0].season + "")) set_data(t2, t2_value);
		},
		i(local) {
			if (current) return;
			transition_in(if_block);
			transition_in(localized.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(if_block);
			transition_out(localized.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div1);
			if (if_block) if_block.d();
			destroy_component(localized);
			if (detaching) detach(t1);
			if (detaching) detach(div3);
		}
	};
}

// (78:20) {#if status}
function create_if_block_2(ctx) {
	let span1;
	let informationcirclesmall;
	let t0;
	let span0;
	let t1;
	let current;
	informationcirclesmall = new InformationCircleSmall({});

	return {
		c() {
			span1 = element("span");
			create_component(informationcirclesmall.$$.fragment);
			t0 = space();
			span0 = element("span");
			t1 = text(/*status*/ ctx[1]);
			this.h();
		},
		l(nodes) {
			span1 = claim_element(nodes, "SPAN", { class: true });
			var span1_nodes = children(span1);
			claim_component(informationcirclesmall.$$.fragment, span1_nodes);
			t0 = claim_space(span1_nodes);
			span0 = claim_element(span1_nodes, "SPAN", { class: true });
			var span0_nodes = children(span0);
			t1 = claim_text(span0_nodes, /*status*/ ctx[1]);
			span0_nodes.forEach(detach);
			span1_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(span0, "class", "pointer-events-none opacity-0 group-hover:opacity-100 transition-opacity shadow rounded rounded-bl-none absolute bottom-5 w-60 border bg-blue-100 text-blue-800 border-blue-400 px-2 py-2");
			attr(span1, "class", "z-10 inline-block h-4 w-4 relative text-blue-400 group");
		},
		m(target, anchor) {
			insert(target, span1, anchor);
			mount_component(informationcirclesmall, span1, null);
			append(span1, t0);
			append(span1, span0);
			append(span0, t1);
			current = true;
		},
		p(ctx, dirty) {
			if (!current || dirty & /*status*/ 2) set_data(t1, /*status*/ ctx[1]);
		},
		i(local) {
			if (current) return;
			transition_in(informationcirclesmall.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(informationcirclesmall.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(span1);
			destroy_component(informationcirclesmall);
		}
	};
}

// (93:28) <time slot="2" datetime={episode.updated_at}>
function create__2_slot(ctx) {
	let time;
	let t_value = /*timeAgo*/ ctx[10].format(new Date(/*episode*/ ctx[0].updated_at)) + "";
	let t;
	let time_datetime_value;

	return {
		c() {
			time = element("time");
			t = text(t_value);
			this.h();
		},
		l(nodes) {
			time = claim_element(nodes, "TIME", { slot: true, datetime: true });
			var time_nodes = children(time);
			t = claim_text(time_nodes, t_value);
			time_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(time, "slot", "2");
			attr(time, "datetime", time_datetime_value = /*episode*/ ctx[0].updated_at);
		},
		m(target, anchor) {
			insert(target, time, anchor);
			append(time, t);
		},
		p(ctx, dirty) {
			if (dirty & /*timeAgo, episode*/ 1025 && t_value !== (t_value = /*timeAgo*/ ctx[10].format(new Date(/*episode*/ ctx[0].updated_at)) + "")) set_data(t, t_value);

			if (dirty & /*episode*/ 1 && time_datetime_value !== (time_datetime_value = /*episode*/ ctx[0].updated_at)) {
				attr(time, "datetime", time_datetime_value);
			}
		},
		d(detaching) {
			if (detaching) detach(time);
		}
	};
}

// (34:0) {#key $lang}
function create_key_block(ctx) {
	let if_block_anchor;
	let current;
	let if_block = /*episode*/ ctx[0] && create_if_block(ctx);

	return {
		c() {
			if (if_block) if_block.c();
			if_block_anchor = empty();
		},
		l(nodes) {
			if (if_block) if_block.l(nodes);
			if_block_anchor = empty();
		},
		m(target, anchor) {
			if (if_block) if_block.m(target, anchor);
			insert(target, if_block_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			if (/*episode*/ ctx[0]) {
				if (if_block) {
					if_block.p(ctx, dirty);

					if (dirty & /*episode*/ 1) {
						transition_in(if_block, 1);
					}
				} else {
					if_block = create_if_block(ctx);
					if_block.c();
					transition_in(if_block, 1);
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				}
			} else if (if_block) {
				group_outros();

				transition_out(if_block, 1, 1, () => {
					if_block = null;
				});

				check_outros();
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			if (if_block) if_block.d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

function create_fragment(ctx) {
	let previous_key = /*$lang*/ ctx[5];
	let key_block_anchor;
	let current;
	let key_block = create_key_block(ctx);

	return {
		c() {
			key_block.c();
			key_block_anchor = empty();
		},
		l(nodes) {
			key_block.l(nodes);
			key_block_anchor = empty();
		},
		m(target, anchor) {
			key_block.m(target, anchor);
			insert(target, key_block_anchor, anchor);
			current = true;
		},
		p(ctx, [dirty]) {
			if (dirty & /*$lang*/ 32 && safe_not_equal(previous_key, previous_key = /*$lang*/ ctx[5])) {
				group_outros();
				transition_out(key_block, 1, 1, noop);
				check_outros();
				key_block = create_key_block(ctx);
				key_block.c();
				transition_in(key_block);
				key_block.m(key_block_anchor.parentNode, key_block_anchor);
			} else {
				key_block.p(ctx, dirty);
			}
		},
		i(local) {
			if (current) return;
			transition_in(key_block);
			current = true;
		},
		o(local) {
			transition_out(key_block);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(key_block_anchor);
			key_block.d(detaching);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let aired;
	let marked;
	let waitingOnRelease;
	let inProgress;
	let noProgress;
	let uniqueStaff;
	let shouldWrap;
	let timeAgo;
	let $lang;
	const lang = getContext("lang");
	component_subscribe($$self, lang, value => $$invalidate(5, $lang = value));
	let { episode } = $$props;
	let { status } = $$props;
	let { latest = false } = $$props;
	let { inList = false } = $$props;

	$$self.$$set = $$props => {
		if ("episode" in $$props) $$invalidate(0, episode = $$props.episode);
		if ("status" in $$props) $$invalidate(1, status = $$props.status);
		if ("latest" in $$props) $$invalidate(2, latest = $$props.latest);
		if ("inList" in $$props) $$invalidate(12, inList = $$props.inList);
	};

	$$self.$$.update = () => {
		if ($$self.$$.dirty & /*episode*/ 1) {
			$: $$invalidate(3, aired = hasAired(episode));
		}

		if ($$self.$$.dirty & /*episode*/ 1) {
			$: $$invalidate(13, marked = allMarked(episode));
		}

		if ($$self.$$.dirty & /*aired, marked*/ 8200) {
			$: $$invalidate(6, waitingOnRelease = aired && marked);
		}

		if ($$self.$$.dirty & /*aired, marked*/ 8200) {
			$: $$invalidate(7, inProgress = aired && !marked);
		}

		if ($$self.$$.dirty & /*episode*/ 1) {
			$: $$invalidate(8, noProgress = !someMarked(episode));
		}

		if ($$self.$$.dirty & /*episode*/ 1) {
			$: $$invalidate(4, uniqueStaff = deduplicateStaff(episode.staff.filter(staff => !staff.finished)));
		}

		if ($$self.$$.dirty & /*inList, uniqueStaff*/ 4112) {
			$: $$invalidate(9, shouldWrap = inList || uniqueStaff.length > 5);
		}

		if ($$self.$$.dirty & /*$lang*/ 32) {
			$: $$invalidate(10, timeAgo = createLocalization($lang).timeAgo);
		}
	};

	return [
		episode,
		status,
		latest,
		aired,
		uniqueStaff,
		$lang,
		waitingOnRelease,
		inProgress,
		noProgress,
		shouldWrap,
		timeAgo,
		lang,
		inList,
		marked
	];
}

class Episode extends SvelteComponent {
	constructor(options) {
		super();

		init(this, options, instance, create_fragment, safe_not_equal, {
			episode: 0,
			status: 1,
			latest: 2,
			inList: 12
		});
	}
}

export default Episode;
//# sourceMappingURL=Episode.svelte.js.map
